import styled from "styled-components";

export const FormContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 2rem;
`